module.exports = __webpack_public_path__ + "img/doorbell_power.24d9cbd2.png";